import './ArticleDetailPage.css';
import { Chip } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "../utils/axios";
import { transformArticleResponse } from "./ArticleOverviewPage";
import Divider from '@mui/material/Divider';
import parse from 'html-react-parser';
import React from 'react';
import useAuth from "../hooks/useAuth";

const ArticleDetailPage = () => {
    const {auth} = useAuth();
    const [article, setArticle] = useState(null);
    const urlParams = useParams();
    const articleId = urlParams?.id;
    const navigate = useNavigate();

    const getArticle = async() => {
        try {
            let config = {
                headers: {
                  'Authorization': `Bearer ${auth?.accessToken}`
                }
              }
            const response = await axios.get(`article/${articleId}`, config)
            const transArticle = transformArticleResponse(response.data)
            setArticle(transArticle)
        } catch (error) {
            console.error(error)
            navigate('/pagenotfound', {replace: true})
        }
    }
    
    useEffect(() => {
        getArticle();
    }, []);

    var articleContent = <div></div>;
    if (article) {        
        var content = article.content;
        // const regexp = new RegExp('<iframe\s*.*>\s*.*<\/iframe>','gi');
        // const iframes = content.match(regexp); 
        // if (iframes) {
        //     iframes.forEach(function (iframe) {
        //         var wrappedIframe = '<div class="div-iframe"><p class="p-iframe">' + iframe +'</p></div>'
        //         content = content.replace(iframe, wrappedIframe);
        //     });
        // }        
        var parsedContent = parse(content);   
        articleContent = React.createElement('div', { className: 'article-content-div' }, parsedContent);
    }   

    return (
        <>
            {article &&
                <div>
                    <h1 style={{textAlign: 'left'}}>{article.title}</h1>
                    <div style={{display: 'inline-block'}}>
                        {article?.tags && <div style={{marginBottom: "2vh"}}>Tags: {article?.tags?.map((tag, index) => <Chip key={index} label={`#${tag}`} size="small" />)}</div>}
                    </div>                         
                    <div style={{width: "10em", marginBottom: '2vh'}}>
                        <Divider variant="fullWidth" sx={{ borderBottomWidth: "0.2em" }} />  
                    </div>                
                    {/*  check for security breach */}
                    {articleContent}
                </div>
            }
        </>
    );


}

export default ArticleDetailPage;